import React, { Component } from 'react';
import styled from 'styled-components';

class AnimateIn extends Component {

    constructor() {
        super();

        this.state = {
            visible: false,
        }

    }

    componentDidMount() {
        this.mounted = true;
        window.addEventListener('scroll', this._onScroll.bind(this));
        this._checkIfInView.bind(this)(1);
    }

    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener('scroll', this._onScroll.bind(this));
    }

    _onScroll(e) {
        this._checkIfInView.bind(this)();
    }

    _checkIfInView(offset) {
        const triggerOffset = offset ? offset : (this.props.offset || 0);
        if(this.instance && this.instance.getBoundingClientRect().top + triggerOffset <= window.innerHeight && !this.state.visible) {
            if(this.mounted) {
                this.setState({ visible: true });
                if(this.props.onEnter) this.props.onEnter();
            }
        }
    }

    render() {
        return (
            <Wrapper visible={this.state.visible} isDisabled={this.props.isDisabled}>
                <div ref={el => this.instance = el} />
                {this.props.children}
            </Wrapper>
        );
    }
}

export default AnimateIn;

const Wrapper = styled.div`
    transform: translateY(50px);
    opacity: 0;
    transition: all .5s ease-out;
    width:100%;
    ${props => props.visible ? `
        transform: translateY(0);
        opacity: 1;
    ` : ``}
    ${props => props.isDisabled ? `
        transform: translateY(0);
        opacity: 1;
    ` : ``}
`



// WEBPACK FOOTER //
// ./src/partials/AnimateIn.js